
export class Elo {
  players: Record<string, number>;
  factor: number
  constructor() {
    this.players = {}
    this.factor = 32
  }

  addPlayer(id: string) {
    this.players[id] = 1000
  }

  compete(id1: string, id2: string, result: number) {
    if (!(id1 in this.players) || !(id2 in this.players) || ![1 | 0 | 0.5].includes(result)) return
    const new1 = this.players[id1] + this.getRatingDelta(id1, id2, result);
    const new2 = this.players[id2] + this.getRatingDelta(id2, id1, 1 - result);
    this.players[id1] = new1;
    this.players[id2] = new2
  }

  getRatingDelta(id1: string, id2: string, result: number): number {
    if (!(id1 in this.players) || !(id2 in this.players)) return 0;
    const myChanceToWin = 1 / ( 1 + Math.pow(10, (this.players[id2] - this.players[id1]) / 400));
    return this.factor * (result - myChanceToWin)
  }

  lowerFactor() {
    this.factor = this.factor * 0.97
  }
}
